"use strict";
exports.__esModule = true;
exports.TYPES = void 0;
exports.TYPES = {
    YOUTUBE: "#3BC3B7",
    MUSIC: "#DBA507",
    FILM_PROD: "#007bff",
    FILM_WORK: "#ff005e",
    COMEDIAN: "#ff1493",
    SOUND_PROD: "#28a745",
    AUDIO_PLUGIN: "#000000"
};
